export default __webpack_public_path__ + "static/media/Arrow_disabled.1467c825.svg";